var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    fill: "none",
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M46.5678 8.51961C41.2932 3.16013 32.7407 3.16013 27.4661 8.51961C26.8155 9.18068 26.2504 9.89208 25.7619 10.6401C25.2734 9.89208 24.7061 9.1784 24.0577 8.51961C18.7831 3.16013 10.2306 3.16013 4.95598 8.51961C-0.318661 13.8791 -0.318661 22.5691 4.95598 27.9286L25.7597 49.0714L46.5678 27.9286C51.8425 22.5691 51.8425 13.8791 46.5678 8.51961Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M29.8486 47.8841C29.8486 47.8841 45.3266 32.5337 48.3548 29.0945C51.3829 25.6553 52.2625 20.4604 52.2625 20.4604C52.2625 20.4604 53.2056 27.3862 48.995 31.6177C44.7844 35.8491 31.3858 49.3848 31.3858 49.3848L29.8486 47.8841Z",
    clipRule: "evenodd",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.4f66db44eb356d47934aa545b80ec6ef.svg";
export { ForwardRef as ReactComponent };